<!-- 组件模板内容 -->
<template>
  <div>
    <el-upload
      class="upload-demo"
      drag
      action="string"
      :http-request="handleChange"
      :file-list="fileList"
      :disabled="disabled"
      ref="upload"
      multiple
      :auto-upload="true"
      :accept="accept"
      :show-file-list="hidenList"
    >
    <!-- :limit="limit" -->
      <i class="el-icon-upload" v-if="!loading"></i>
      <el-spinner v-else style="margin: 20px;"></el-spinner>
      <div class="el-upload__text" v-if="!loading">将文件拖到此处，或<em>点击选取文件</em></div>
      <div class="el-upload__text" v-else>文件上传中...</div>
      <div class="el-upload__tip" slot="tip">
        只能上传{{ accept }}文件，且不超过{{ fileSize }}MB
      </div>
    </el-upload>
  </div>
</template>

<script>
import { uploadFileApi, uploadVideoFileApi } from "@/api/uploadFileApi";
export default {
  name: "UploadFile",
  // 组件的props定义,用于子组件接收父组件传值
  props: {
    accept: {
      type: String,
      default: ".mp4,.mkv,.png,.jpg,.jpge",
    },
    fileSize: {
      type: String,
      default: "2",
    },
    moduleName: {
      type: String,
      required: true,
    },
    limit: {
      type: Number,
      default: 8,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hidenList:{
      type:Boolean,
      default:true
    }
  },
  // 组件的data属性
  data() {
    return {
      fileList: [],
      loading: false
    };
  },
  // 组件的方法
  methods: {
    async handleChange(param) {
      this.loading = true;
      try {
        const data = new FormData();
        if (param) {
          data.append("file", param.file);
          data.append("moduleName", this.moduleName);
          if (this.moduleName === "video") {
            if (param.file.size >= 100 * 1024 * 1024) {
              this.$message({
                message: "文件过大,最大100MB",
                type: "warning",
              });
              return;
            }
          } else {
            if (param.file.size >= this.fileSize * 1024 * 1024) {
              this.$message({
                message: "文件过大,最大" + this.fileSize + "MB",
                type: "warning",
              });
              return;
            }
          }
        }
        let res;
        if (this.moduleName === "video") {
          res = await uploadVideoFileApi(data);
        } else {
          res = await uploadFileApi(data);
        }

        this.$message({
          message: "上传成功!",
          type: "success",
            });
        this.$emit("upload-success", res, this.fileList);
      } catch (error) {
        this.$message({
          message: "上传失败!",
          type: "error",
        });
      } finally {
        this.loading = false;  // 无论成功或失败都结束加载状态
      }
    },
  },
  // 在created钩子中执行的操作
  created() {},
};
</script>

<!-- 组件的样式 -->
<style scoped>
</style>